module.exports = __webpack_public_path__ + "static/media/reddy.51fc9d07.png";